/*
 * Api lấy dữ liệu bảng lịch sửa chữa bảo dưỡng
 */
import BaseAPI from "./base/base-api";

class ScheduleAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "Schedule";
}

export default new ScheduleAPI();
